var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPrimaryMessageContainer = function SvgPrimaryMessageContainer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 458 260"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEDEE",
    fillRule: "evenodd",
    d: "M203 213.806s-60.417-2.97-72.21 15.059c-4.188 6.401-17.811 2.015-6.224-4.348 11.909-6.541 25.258-13.469 64.985-12.409L203 213.806Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D3D4D5",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M122 227.494c16.816-13.305 49.26-15.415 74.648-14.624 0 0 52.449 3.872 105.458 12.687 11.665 1.939 23.111 2.258 32.543 2.443 32.086-.637 72.347-7.26 80.351-37"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E7E8E9",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M294.5 147.094c32.344 5.269 87.909 20.466 112.278 33.535A11.772 11.772 0 0 1 413 191M352.5 184v9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E7E8E9",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M357.96 178.665c.446 2.943-2.901 5.335-6.479 5.335-3.579 0-6.481-2.388-6.481-5.335s4.462-11.838 7.08-7.488c2.021 3.359 5.195 2.968 5.88 7.488Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E7E8E9",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M367.5 175v18"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M380.913 159.084c-1.349 8.125-6.024 14.916-13.457 14.916-7.431 0-13.456-6.677-13.456-14.916 0-8.238 6.359-31.83 11.796-19.668 4.199 9.389 16.35 12.241 15.117 19.668Z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E7E8E9",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M380.913 159.084c-1.349 8.125-6.024 14.916-13.457 14.916-7.431 0-13.456-6.677-13.456-14.916 0-8.238 6.359-31.83 11.796-19.668 4.199 9.389 16.35 12.241 15.117 19.668Z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D3D4D5",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M391 231c16.497-9.543 29-22.57 29-40.26 0-3.751-5.881-3.74-5.881-3.74"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E7E8E9",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M413 186s13.052.923 19 9"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEDEE",
    fillRule: "evenodd",
    d: "M337 208c0 .552-2.91 1-6.499 1-3.591 0-6.501-.448-6.501-1 0-.553 2.91-1 6.501-1 3.589 0 6.499.447 6.499 1Z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M342 198.197c0 4.862-4.477 8.803-9.999 8.803-5.524 0-10.001-3.941-10.001-8.803 0-4.863 3.645-4.009 10.001-8.804 6.357-4.795 9.999 3.941 9.999 8.804Z",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D3D4D5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.025,
    d: "M342 198.197c0 4.862-4.477 8.803-9.999 8.803-5.524 0-10.001-3.941-10.001-8.803 0-4.863 3.645-4.009 10.001-8.804 6.357-4.795 9.999 3.941 9.999 8.804Z",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEDEE",
    fillRule: "evenodd",
    d: "M315 208c0 .552-2.238 1-5 1s-5-.448-5-1 2.238-1 5-1 5 .448 5 1Z",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M319 199.553c0 3.56-3.581 6.447-7.999 6.447-4.42 0-8.001-2.887-8.001-6.447 0-3.562 3.485-10.178 8.001-6.447 3.55 3.932 7.999 2.885 7.999 6.447Z",
    clipRule: "evenodd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D3D4D5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.025,
    d: "M319 199.553c0 3.56-3.581 6.447-7.999 6.447-4.42 0-8.001-2.887-8.001-6.447 0-3.562 3.485-10.178 8.001-6.447 3.55 3.932 7.999 2.885 7.999 6.447Z",
    clipRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEDEE",
    fillRule: "evenodd",
    d: "M324.892 193.697s2.869-2.054 4.508.89c1.639 2.943.683 10.54 5.6 9.786-1.776.481-4.985 1.644-9.015-1.368-4.029-3.012-3.552-7.733-1.093-9.308Zm-19.473 2.826s2.152-1.54 3.381.667c1.23 2.207.514 7.904 4.2 7.341-1.331.359-3.738 1.232-6.76-1.027-3.023-2.259-2.665-5.8-.821-6.981Z",
    clipRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F4F5",
    fillRule: "evenodd",
    d: "M347.741 176s1.782.641 2.537 3.224c.757 2.584 2.361 4.047 3.722 3.592-2.193.607-9.288.041-6.259-6.816Zm7.731-21s5.659 2.152 7.296 7.735c1.637 5.583 7.285 9.826 10.232 8.841-5.652 4.054-20.86-.268-17.528-16.576Z",
    clipRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEDEE",
    fillRule: "evenodd",
    d: "M321 234c0 .552.671 1 1.5 1 .828 0 1.5-.448 1.5-1s-.672-1-1.5-1c-.829 0-1.5.448-1.5 1Z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "primary-messageContainer_svg__a",
    width: 4,
    height: 2,
    x: 364,
    y: 238,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M364.196 238.34h2.95V240h-2.95v-1.66Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#primary-messageContainer_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ECEDEE",
    fillRule: "evenodd",
    d: "M364.196 239.17c0 .458.66.83 1.475.83.815 0 1.475-.372 1.475-.83 0-.458-.66-.83-1.475-.83-.815 0-1.475.372-1.475.83Z",
    clipRule: "evenodd"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEDEE",
    fillRule: "evenodd",
    d: "M338 231.5c0 .276.449.5.999.5.552 0 1.001-.224 1.001-.5s-.449-.5-1.001-.5c-.55 0-.999.224-.999.5ZM182 220c0 .552.671 1 1.501 1 .828 0 1.499-.448 1.499-1s-.671-1-1.499-1c-.83 0-1.501.448-1.501 1Zm-28 3c0 .552 1.343 1 3.001 1 1.656 0 2.999-.448 2.999-1s-1.343-1-2.999-1c-1.658 0-3.001.448-3.001 1Zm13 3c0 .552 1.343 1 2.999 1 1.658 0 3.001-.448 3.001-1s-1.343-1-3.001-1c-1.656 0-2.999.448-2.999 1Zm-24 7c0 .553.672 1 1.499 1 .829 0 1.501-.447 1.501-1 0-.553-.672-1-1.501-1-.827 0-1.499.447-1.499 1Zm167-2c0 .552 1.343 1 3.001 1 1.656 0 2.999-.448 2.999-1s-1.343-1-2.999-1c-1.658 0-3.001.448-3.001 1Zm-12 4c0 .552 1.343 1 3.001 1 1.656 0 2.999-.448 2.999-1s-1.343-1-2.999-1c-1.658 0-3.001.448-3.001 1Z",
    clipRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F4F5",
    fillRule: "evenodd",
    d: "M142 151s-69.922 15.742-89.805 36.516c-9.973 10.419-35.805 4.107-22.438-3.37 18.075-10.113 67.315-28.5 102.843-32.792L142 151Z",
    clipRule: "evenodd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEDEE",
    fillRule: "evenodd",
    d: "M76 181.5c0 .276-1.792.5-4 .5s-4-.224-4-.5 1.792-.5 4-.5 4 .224 4 .5Zm15 1c0 .276-1.792.5-4 .5s-4-.224-4-.5 1.792-.5 4-.5 4 .224 4 .5Z",
    clipRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E7E8E9",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M163.805 147.094C122.299 151.821 59.298 165.907 29 184"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEDEE",
    fillRule: "evenodd",
    d: "M136 204c0 .552-2.91 1-6.499 1-3.591 0-6.501-.448-6.501-1 0-.553 2.91-1 6.501-1 3.589 0 6.499.447 6.499 1Z",
    clipRule: "evenodd"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M142 194.197c0 4.862-4.477 8.803-9.999 8.803-5.524 0-10.001-3.941-10.001-8.803 0-4.863 3.643-4.009 10.001-8.804 6.357-4.795 9.999 3.941 9.999 8.804Z",
    clipRule: "evenodd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D3D4D5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.025,
    d: "M142 194.197c0 4.862-4.477 8.803-9.999 8.803-5.524 0-10.001-3.941-10.001-8.803 0-4.863 3.643-4.009 10.001-8.804 6.357-4.795 9.999 3.941 9.999 8.804Z",
    clipRule: "evenodd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEDEE",
    fillRule: "evenodd",
    d: "M112 208c0 .552-2.238 1-5 1s-5-.448-5-1 2.238-1 5-1 5 .448 5 1Z",
    clipRule: "evenodd"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M116 199.553c0 3.561-3.581 6.447-7.999 6.447-4.42 0-8.001-2.886-8.001-6.447 0-3.562 3.485-10.178 8.001-6.447 3.55 3.932 7.999 2.885 7.999 6.447Z",
    clipRule: "evenodd"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    stroke: "#D3D4D5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.025,
    d: "M116 199.553c0 3.561-3.581 6.447-7.999 6.447-4.42 0-8.001-2.886-8.001-6.447 0-3.562 3.485-10.178 8.001-6.447 3.55 3.932 7.999 2.885 7.999 6.447Z",
    clipRule: "evenodd"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#ECEDEE",
    fillRule: "evenodd",
    d: "M124.892 190.697s2.869-2.054 4.508.89c1.639 2.942.683 10.541 5.6 9.787-1.776.48-4.986 1.643-9.014-1.368-4.031-3.012-3.553-7.735-1.094-9.309Zm-22.473 5.826s2.152-1.54 3.382.667c1.229 2.207.511 7.906 4.199 7.341-1.331.359-3.738 1.232-6.761-1.027-3.022-2.259-2.664-5.8-.82-6.981Z",
    clipRule: "evenodd"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M79.96 168.665c.446 2.943-2.9 5.335-6.479 5.335S67 171.612 67 168.665c0-2.946 4.462-11.838 7.08-7.488 2.022 3.36 5.196 2.968 5.88 7.488Z",
    clipRule: "evenodd"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E7E8E9",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M79.96 168.665c.446 2.943-2.9 5.335-6.479 5.335S67 171.612 67 168.665c0-2.946 4.462-11.838 7.08-7.488 2.022 3.36 5.196 2.968 5.88 7.488Z",
    clipRule: "evenodd"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E7E8E9",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M87.5 164v18M73.5 174v7"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M100.976 149.29c-.416 8.176-4.712 14.71-12.277 14.71C81.134 164 75 157.364 75 149.177c0-8.186 8.328-51.223 13.214-32.507 4.671 17.888 13.304 21.924 12.762 32.62Z",
    clipRule: "evenodd"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E7E8E9",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M100.976 149.29c-.416 8.176-4.712 14.71-12.277 14.71C81.134 164 75 157.364 75 149.177c0-8.186 8.328-51.223 13.214-32.507 4.671 17.888 13.304 21.924 12.762 32.62Z",
    clipRule: "evenodd"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F4F5",
    fillRule: "evenodd",
    d: "M68.74 165s1.782.642 2.538 3.224c.757 2.583 2.36 4.046 3.722 3.592-2.193.607-9.288.04-6.26-6.816Zm7.732-20s5.658 2.152 7.295 7.735c1.639 5.583 7.284 9.826 10.233 8.841-5.653 4.054-20.86-.268-17.528-16.576Z",
    clipRule: "evenodd"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0E4E3",
    fillRule: "evenodd",
    d: "M222.934 114.339c4.59 3.255 11.404 9.528 7.589 11.93-3.88 0-17.211-15.088-17.211-15.088l-2.386-5.748 2.486-5.133 3.88-1.95s-2.185 10.439 5.642 15.989Z",
    clipRule: "evenodd"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F4F5",
    fillRule: "evenodd",
    d: "M270.366 169.498c0 2.486-18.548 4.502-41.429 4.502-22.881 0-41.428-2.016-41.428-4.502 0-2.487 18.547-4.504 41.428-4.504 22.881 0 41.429 2.017 41.429 4.504Z",
    clipRule: "evenodd"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    stroke: "#008381",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M290.18 102.005v5.386c-.018 32.329-26.041 58.523-58.123 58.504-32.083-.019-58.075-26.242-58.057-58.572.018-32.329 26.041-58.523 58.123-58.504a57.714 57.714 0 0 1 23.61 5.068"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    stroke: "#008A00",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M231.319 125.368a7.417 7.417 0 0 1-5.22-2.141l-13.011-12.891a7.264 7.264 0 0 1 0-10.342c2.884-2.856 7.558-2.856 10.44 0l7.789 7.717 38.152-37.835c2.883-2.857 7.555-2.861 10.441-.005a7.265 7.265 0 0 1 .005 10.341l-43.373 43.011a7.413 7.413 0 0 1-5.221 2.145h-.002Z",
    clipRule: "evenodd"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0E4E3",
    fillRule: "evenodd",
    d: "M205.939 65.03s-32.156 39.944-2.881 68.794c29.277 28.85 66.408 4.904 66.408 4.904s-20.087 25.856-56.371 14.276c-22.841-9.724-40.925-38.738-24.874-68.852 8.345-13.34 12.598-15.74 17.718-19.123Z",
    clipRule: "evenodd"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    stroke: "#008381",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M281.174 103.32v4.515c-.015 27.108-22.003 49.07-49.111 49.054-27.11-.015-49.072-22.003-49.057-49.109.015-27.108 22.004-49.07 49.112-49.055a49.087 49.087 0 0 1 19.949 4.25"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    stroke: "#C0E4E3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M231.189 20v11.708M248.752 21.801l-1.802 10.807M264.963 26.304l-3.603 10.807M280.273 34.41l-6.304 9.906M293.783 46.117l-8.106 8.105M304.59 58.725l-9.907 6.304M312.696 74.035l-10.808 3.602M317.199 90.246l-10.808 1.801M319 107.807h-11.708"
  })));
};
export default SvgPrimaryMessageContainer;